import { useMemo } from 'react';

import { resolveWidgets } from '@/config/resolve-widgets';
import { DASHBOARD_WIDGETS } from '@/config/widgets.config';

import { useSettingsQuery } from './queries/use-settings-query';

export function useResolvedWidgets() {
  const { data: settings } = useSettingsQuery();
  return useMemo(
    () => resolveWidgets(DASHBOARD_WIDGETS, settings?.dashboard?.widgets),
    [settings?.dashboard?.widgets]
  );
}
